webpackJsonp([146958353494356],{

/***/ 2142:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LocationOrLocationTag","kind":"UNION","type":"OBJECT","fields":null,"description":null,"enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"Location","ofType":null},{"kind":"OBJECT","name":"LocationTag","ofType":null}]}}

/***/ })

});


// WEBPACK FOOTER //
// path---union-location-or-location-tag-8a7a9110f138567b2b6b.js